import { useEffect, useState } from 'react'

// Census geo data (geoData, map features, raw datasets) lives in a separate chunk
// that is only downloaded when a form actually contains the census division element.
// Forms are preloaded through the `preload` entry in formComponentTypes, so sync
// helpers (save, validation) can use getCensusGeoData() safely.

let censusGeoData = null
let loadingPromise = null

export const loadCensusGeoData = () => {
  if (!loadingPromise) {
    loadingPromise = import(/* webpackChunkName: "census-geo-data" */ './censusGeoData')
      .then((module) => {
        console.log('qqq', module)
        censusGeoData = module
        return module
      })
      .catch((error) => {
        // allow retrying, e.g. after a network hiccup
        loadingPromise = null
        throw error
      })
  }
  return loadingPromise
}

/**
 * Returns loaded census geo data. Throws if used before loadCensusGeoData() resolved,
 * so a missing preload fails loudly instead of silently saving or validating empty values.
 */
export const getCensusGeoData = () => {
  if (!censusGeoData) {
    throw new Error('Census geo data used before it was loaded - call loadCensusGeoData() first')
  }
  return censusGeoData
}

/** Loads census geo data on mount. Returns the data, or null while loading. */
export const useCensusGeoData = () => {
  const [data, setData] = useState(censusGeoData)
  useEffect(() => {
    if (data) {
      return
    }
    let active = true
    loadCensusGeoData()
      .then((module) => active && setData(module))
      .catch((error) => console.error('Failed to load census geo data', error))
    return () => {
      active = false
    }
  }, [data])
  return data
}
